import { preload_fix } from './image_control';

export function waypoints(object){

    console.log('Waypoints called');

	object.waypoint(function(direction) {
		var directionis = direction;
		var iam = $(this.element);
		iam.toggleClass('go', directionis === 'down');
	
		preload_fix();
		//console.log('waypoint'); 
	},{ 
	  offset:'60%'  
	}); 

	object.waypoint(function(direction) {
		var directionis = direction;
		var iam = $(this.element);
		iam.find('.preload-img').addClass('load'); 

		preload_fix();
		console.log('waypoint image preloader'); 
	},{ 
	  offset:'98%'  
	});
	

	//UP
	object.waypoint(function(direction) {
		var directionis = direction;
		var iam = $(this.element);
		iam.find('.preload-img').addClass('load');
		iam.toggleClass('go', directionis === 'up');
		
		preload_fix();
		//console.log('waypoint');
	},{   
	offset: function() {  return -$(this.element).outerHeight(); }
	}); 
}